<template>
    <div class="textarea-bot-wrapper">
        <Icon class="text-face" :bgPosition="facePosition" @iconClick.self="showEmoji" />
        <div class="operate-box">
            <div class="operate-item text-edit-cmd-param" @click="clearStyle">清除格式</div>
            <div
                v-show="!hiddenButtons['portrait']"
                :class="{ 'disabled-edit': disabledCmd }"
                class="operate-item"
                @click.stop="itemClickHandle('portrait', $event)"
            >
                <i class="el-icon-plus"></i>
                {{ portraitLabel }}
            </div>
            <div :class="{ 'disabled-edit': canEdit }" class="operate-item highlight-word" @click="itemClickHandle('highlight', $event)">
                {{ highlightWord }}
            </div>
            <div
                :class="{ 'disabled-edit': canEdit }"
                v-show="!hiddenButtons['question']"
                class="operate-item"
                @click="itemClickHandle('question', $event)"
            >
                {{ linkQuestionLabel }}
            </div>
            <div
                :class="{ 'disabled-edit': canEdit }"
                v-show="!hiddenButtons['link']"
                class="operate-item text-opt-link"
                @click="itemClickHandle('link', $event)"
            >
                {{ hiLinkLabel }}
            </div>
            <div class="magnify-btn" @click="magnify">{{isRichInputBig ? lessenLabel : magnifyLabel}}</div>
        </div>
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";

export default {
    name: "TextOperateBar",
    props: ["disabled", "hiddenBtns", "disabledCmd", "isRichInputBig"],
    components: {
        Icon
    },
    computed: {
        canEdit() {
            if (this.disabled) {
                return true;
            } else {
                return false;
            }
        },
        computedPostion() {
            let position = this.hiWordPosition;
            this.canEdit ? (position = "-341px -15px") : "";

            return position;
        },
        highlightWord() {
            return this.$t("zhiji.answer.textWidget.hightTip");
        },
        hiLinkLabel() {
            return this.$t("zhiji.answer.textWidget.textLink");
        },
        linkQuestionLabel() {
            return this.$t("zhiji.answer.textWidget.linkQuestion");
        },
        portraitLabel() {
            return this.$t("zhiji.answer.textWidget.addPortrait");
        },
        hiddenButtons() {
            return this.hiddenBtns || {};
        },
        magnifyLabel() {
            return this.$t("zhiji.answer.textWidget.magnifyLabel");
        },
        lessenLabel() {
            return this.$t("zhiji.answer.textWidget.lessenLabel");
        }
    },
    data() {
        return {
            facePosition: "-297px -21px",
            hiWordPosition: "-341px -31px",
        };
    },
    methods: {
        showEmoji() {
            this.$emit("showEmoji");
        },
        clearStyle() {
            this.$emit("clearStyle")
        },
        magnify() {
            this.$emit('magnify')
        },
        itemClickHandle(type, event) {
            if (type === "portrait" && this.disabledCmd) {
                return;
            } else if (type !== "portrait" && this.disabled) {
                return;
            }
            this.$emit("itemClick", { type, event });
        }
    }
};
</script>

<style lang="less" scoped>
.textarea-bot-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px 0 8px;
    height: 33px;
    border-radius: 0 0 4px 4px;
    background: #d9e4ef;

    .text-face {
        display: none;
        width: 21px;
        height: 20px;
        cursor: pointer;
    }

    .operate-box {
        display: flex;
        width: 100%;
        justify-content: flex-end;

        .disabled-edit {
            font-size: 12px;
            height: 25px;
            line-height: 25px;
            background: #fff;
            border-radius: 4px;
            color: #c9c9c9;
            padding: 0 8px;
            cursor: pointer;
        }

        .disabled-edit.text-opt-link {
            &:before {
                display: inline-block;
                content: "";
                width: 15px;
                height: 15px;
                vertical-align: -3px;
                margin-right: 4px;
                background: url("@{zhijiStaticImagePath}class-spr.png") -342px 0;
            }
        }
    }

    .operate-item, .magnify-btn {
        font-size: 12px;
        height: 25px;
        line-height: 25px;
        background: #fff;
        border-radius: 4px;
        padding: 0 8px;
        cursor: pointer;
        margin-right: 8px;
    }

    .magnify-btn {
        margin-right: 0px;
        margin-left: 8px;
    }

    .highlight-word {
        // TODO 高亮一期不上
        // display: none;
    }

    .hiWord-icon {
        position: relative;
        top: 2px;
        display: inline-flex;
        width: 16px;
        flex-direction: column;

        .word-color {
            width: 15px;
            height: 3px;
            position: relative;
            top: -4px;
        }
    }

    .text-opt-link {
        margin-right: 0;

        &:before {
            display: inline-block;
            content: "";
            width: 15px;
            height: 15px;
            vertical-align: -3px;
            margin-right: 4px;
            background: url("@{zhijiStaticImagePath}class-spr.png") -322px 0;
        }
    }
}
</style>
